import React from 'react';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import DataCombobox from 'components/DataCombobox';
import './index.css';

export default class SiteDropdownInput extends React.Component {
  render() {
    const { value, labels, callback, valueListCallback, attributeName, placeholder, apiUrl, filter, disabled } = this.props;
    return (
        <div>
          <Label>{labels[attributeName]}</Label>
          <FormGroup>
              <DataCombobox
                apiUrl={apiUrl}
                onChange={(value) => callback(attributeName, value)}
                valueListCallback={(valueList) => valueListCallback(valueList)}
                value={value}
                placeholder={placeholder}
                filter={filter}
                disabled={disabled}
              />
          </FormGroup>
        </div>
    );
  }
}